import { useState } from 'react';
import { useDispatch } from 'react-redux';
import SplitButton from '@components/SplitButton';
import { useTranslation, trackExport } from '@hooks';
import { handleApiError } from '@helpers/api';
import { downloadBlobAs } from '@helpers/download';
import { alertActions } from '@actions';

const ExportButton = ({ callback, type, sx = {} }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onExport = async format => {
        setIsSubmitting(true);
        try {
            const response = await callback(format);
            if (response?.exportStatusId) {
                trackExport(response.exportStatusId);
                dispatch(
                    alertActions.success(t('exports.exporting'), { id: response.exportStatusId, persistent: true }),
                );
            } else if (typeof response === 'string') {
                const ext = format === 'xlsx' ? 'xlsx' : 'csv';
                downloadBlobAs(response, `${type}.${ext}`);
            }
        } catch (error) {
            handleApiError(error, 'common.exportError');
        }
        setIsSubmitting(false);
    };

    const options = [
        { text: t('buttons.exportAsCSV'), onClick: () => onExport('csv') },
        { text: t('buttons.exportAsExcel'), onClick: () => onExport('xlsx') },
    ];

    return <SplitButton variant="outlined" options={options} disabled={isSubmitting} sx={{ flexShrink: 0, ...sx }} />;
};

export default ExportButton;
